import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { OpsappService } from '../../services/opsapp.service';

@Component({
  selector: 'app-ops-dashboard',
  templateUrl: './ops-dashboard.component.html',
  styleUrls: ['./ops-dashboard.component.css']
})
export class OpsDashboardComponent implements OnInit {
  dashboardData: any;
  dashboardLoading: boolean = true;

  constructor(private opsappService: OpsappService, 
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService){
  }

  ngOnInit(){
    this.populateDashboard();
  }

  populateDashboard(){
    this.dashboardLoading = true;
    this.opsappService.getOpsDashboard().then(data => {
      this.dashboardData = data;
      this.dashboardLoading = false;
    });
  }
}
